import { useQuery, useSuspenseQuery } from '@tanstack/react-query';


import { cacheKeys } from '../config';
import { tributeClient } from '../client/tributeClient';


export type Params = {
  id: number | string;
};

type Options = {
  enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

const isMarketingId = (id: string | number) =>
  id === 'hopeling' || id === 'luna';

export const useTribute = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: tribute } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getTribute, params.id],
    queryFn: () => (
      isMarketingId(params.id)
        ? tributeClient.getMarketingTribute(params)
        : tributeClient.getTribute(params)
    ),
    ...defaultOptions,
    ...options,
  });

  return {
    ...rest,
    tribute,
  };
};

export const useTributeWithEnabledOption = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: tribute } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getTribute, params.id],
    queryFn: () => (
      isMarketingId(params.id)
        ? tributeClient.getMarketingTribute(params)
        : tributeClient.getTribute(params)
    ),
    ...defaultOptions,
    ...options,
  });

  return {
    ...rest,
    tribute,
  };
};

